import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Stars",
  "use": "Stars-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" class=\"fizz-icon-24\" id=\"Stars\">\n  <path d=\"M24.9 12.2l1.6-3.5L30 7.1l-3.5-1.6L24.9 2l-1.6 3.5-3.5 1.6 3.5 1.6 1.6 3.5zm-9.5.6l-3.2-7-3.2 7L2 16l7 3.2 3.2 7 3.2-7 7-3.2-7-3.2zm9.5 7l-1.6 3.5-3.5 1.6 3.5 1.6 1.6 3.5 1.6-3.5 3.5-1.6-3.5-1.6-1.6-3.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol